import React from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import { Card } from '../../components/ui/Card';
import { KPICard } from '../../components/ui/KPICard';
import { DataTable } from '../../components/ui/DataTable';
import { StatusPill } from '../../components/ui/StatusPill';
import { Button } from '../../components/ui/Button';
import { ShieldCheckIcon, AlertTriangleIcon, CheckCircleIcon, ExternalLinkIcon } from 'lucide-react';
const remediations = [{
  id: 'REM-001',
  issue: 'Missing Anti-Bribery Declaration',
  domain: 'Legal',
  priority: 'High',
  due: '2026-03-25',
  status: 'Pending'
}, {
  id: 'REM-002',
  issue: 'Update Bank Verification',
  domain: 'Financial',
  priority: 'Medium',
  due: '2026-04-10',
  status: 'In Progress'
}];
export const RiskCompliancePage: React.FC = () => {
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-1663">
      <PageHeader title="Risk & Compliance" description="View your risk score, assessments, and remediation tasks." breadcrumbs={[{
      label: 'Home',
      href: '/supplier/dashboard'
    }, {
      label: 'Risk & Compliance'
    }]} data-id="element-1664" />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1665">
        <KPICard title="Overall Risk Score" value="Low Risk" icon={<ShieldCheckIcon className="w-5 h-5 text-status-success" data-id="element-1667" />} data-id="element-1666" />
        <KPICard title="ESG Rating" value="A" icon={<CheckCircleIcon className="w-5 h-5 text-status-success" data-id="element-1669" />} data-id="element-1668" />
        <KPICard title="Open Remediations" value="2" icon={<AlertTriangleIcon className="w-5 h-5 text-status-warning" data-id="element-1671" />} data-id="element-1670" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1672">
        <Card data-id="element-1673">
          <h2 className="text-lg font-semibold text-text-primary mb-4" data-id="element-1674">
            Compliance Domains
          </h2>
          <div className="space-y-4" data-id="element-1675">
            <div className="flex justify-between items-center p-4 border border-border-light rounded-fluent" data-id="element-1676">
              <div data-id="element-1677">
                <h3 className="font-medium text-text-primary" data-id="element-1678">
                  Financial Health
                </h3>
                <p className="text-sm text-text-secondary" data-id="element-1679">
                  Credit score and bank verification
                </p>
              </div>
              <StatusPill status="success" data-id="element-1680" />
            </div>
            <div className="flex justify-between items-center p-4 border border-border-light rounded-fluent" data-id="element-1681">
              <div data-id="element-1682">
                <h3 className="font-medium text-text-primary" data-id="element-1683">
                  Legal & Sanctions
                </h3>
                <p className="text-sm text-text-secondary" data-id="element-1684">
                  Watchlist and adverse media checks
                </p>
              </div>
              <StatusPill status="success" data-id="element-1685" />
            </div>
            <div className="flex justify-between items-center p-4 border border-border-light rounded-fluent" data-id="element-1686">
              <div data-id="element-1687">
                <h3 className="font-medium text-text-primary" data-id="element-1688">
                  ESG & Sustainability
                </h3>
                <p className="text-sm text-text-secondary" data-id="element-1689">
                  Environmental and social governance
                </p>
              </div>
              <StatusPill status="success" data-id="element-1690" />
            </div>
            <div className="flex justify-between items-center p-4 border border-border-light rounded-fluent" data-id="element-1691">
              <div data-id="element-1692">
                <h3 className="font-medium text-text-primary" data-id="element-1693">
                  Information Security
                </h3>
                <p className="text-sm text-text-secondary" data-id="element-1694">
                  Data protection and cyber risk
                </p>
              </div>
              <StatusPill status="warning" data-id="element-1695" />
            </div>
          </div>
        </Card>

        <div className="space-y-6" data-id="element-1696">
          <Card data-id="element-1697">
            <h2 className="text-lg font-semibold text-text-primary mb-4" data-id="element-1698">
              Remediation Tasks
            </h2>
            <DataTable data={remediations} columns={[{
            header: 'Issue',
            accessorKey: 'issue'
          }, {
            header: 'Domain',
            accessorKey: 'domain'
          }, {
            header: 'Due Date',
            accessorKey: 'due'
          }, {
            header: 'Action',
            cell: () => <Button variant="ghost" size="sm" rightIcon={<ExternalLinkIcon className="w-4 h-4" data-id="element-1701" />} data-id="element-1700">
                      Resolve
                    </Button>
          }]} data-id="element-1699" />
          </Card>

          <Card data-id="element-1702">
            <h2 className="text-lg font-semibold text-text-primary mb-4" data-id="element-1703">
              Questionnaires
            </h2>
            <div className="space-y-3" data-id="element-1704">
              <div className="flex justify-between items-center p-3 bg-surface-secondary rounded-fluent" data-id="element-1705">
                <span className="font-medium text-sm" data-id="element-1706">
                  Annual ESG Assessment 2026
                </span>
                <Button variant="secondary" size="sm" data-id="element-1707">
                  Start
                </Button>
              </div>
              <div className="flex justify-between items-center p-3 bg-surface-secondary rounded-fluent" data-id="element-1708">
                <span className="font-medium text-sm" data-id="element-1709">
                  Information Security Review
                </span>
                <span className="text-sm text-status-success font-medium" data-id="element-1710">
                  Completed
                </span>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>;
};